module.exports = __webpack_public_path__ + "img/tv5.68ad9771.gif";